import { useState } from "react"
import { useDispatch } from "react-redux"
import { fileTypeFromStream } from "file-type"

import FileViewModal from "./FileViewModal"

import { raiseToast } from "../services/redux/reducers/toast/toast"
import downloadFile from "../utils/DownloadFile"


const FileViewAndRemove = (props) => {
    const { doc, handleRemoveDoc, docName, showRemove, disableRemove } = props
    let { label } = props

    if (!label) {
        label = "View"
    }

    const [visibleDocViewer, setVisibleDocViewer] = useState(false)

    const dispatch = useDispatch()

    const handleDoc = async (doc) => {
        if (doc.objectURL) {
            window.open(doc.objectURL, "_blank")
        }
        else {
            try {
                const response = await fetch(doc.url)
                if (!response.ok) {
                    dispatch(raiseToast({ severity: 'error', detail: `HTTP error! Status: ${response.status}`, life: 3000 }))
                }
                
                const fileType = await fileTypeFromStream(response.body)
                
                const allowedMimeTypes = ['image/png', 'image/jpeg', 'image/jpg', 'application/pdf']

                if (fileType && allowedMimeTypes.includes(fileType.mime)) {
                    setVisibleDocViewer(true)
                }
                else {
                    downloadFile(doc.url, `${docName}`)
                    dispatch(raiseToast({ severity: 'success', detail: 'File downloaded!' }))
                }
            } catch (error) {
                dispatch(raiseToast({ severity: 'error', detail: 'Failed to fetch file. Please check your network or URL.', life: 3000 }))
            }
        }
    }

    const handleRemoveClick = () => {
        if (docName) {
            handleRemoveDoc(docName)
        }
        else {
            handleRemoveDoc()
        }
    }

    const handleDocViewOnHide = () => {
        setVisibleDocViewer(false)
    }

    return (
        <>
            <div className='flex flex-column'>
                <div>
                    <span onClick={() => handleDoc(doc)} className="cursor-pointer text-sm text-blue-600">
                        {label}
                    </span>
                    {
                        showRemove ?
                            <span onClick={!disableRemove ? handleRemoveClick : null} className={`text-sm ${disableRemove ? 'text-gray-500' : 'text-red-600 cursor-pointer'} ml-2`}>
                                Remove
                            </span>
                            : null
                    }
                </div>
            </div>

            <FileViewModal visible={visibleDocViewer} document={doc.url} handleOnHide={handleDocViewOnHide} docName={docName} />
        </>
    )
}

export default FileViewAndRemove